<template>
    <div>

        <!-- Start Blog Details Area --> 
        <section class="blog-details-area ptb-80 mt-5">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8 col-md-12">
                        <div class="blog-details-desc">
                            <div class="article-image">
                                <img src="../../../../assets/img/blog-image/2.jpg" alt="image">
                            </div>

                            <div class="article-content">
                                <div class="entry-meta">
                                    <ul>
                                        <li><feather type="clock"></feather> <a href="#">September 31, 2020</a></li>
                                        <li><feather type="user"></feather> <a href="#">Steven Smith</a></li>
                                    </ul>
                                </div>

                                <h3>Why does your business need an app?</h3>
                                <p>In today's world everybody has a smartphone and a business owner like you can take advantage of this by creating an app for your business.</p>
                                <p>An app is a very good way to cultivate customer loyalty as it gives you and your customer a genuine way to communicate directly.</p>
                                <p>When it comes down to your product and services then your brand recognition comes into play which can be improved using an app.</p>
                                <p>Your app would be the best medium for digital marketing. It will do all the necessary things such as booking formed account news feeds or anything that you need on the go.</p>
                                <p>it is sometimes impossible to reach the target audience at different places simultaneously. Here is where an app will let you reach all the target audience that you want at any place at any given time.</p>
                            </div>
                    </div>

                    
                </div>
                 <div class="col-lg-4 col-md-12">
                        <aside class="widget-area" id="secondary">
                            <section class="widget widget_search">
                                <form class="search-form">
                                    <label>
                                        <span class="screen-reader-text">Search for:</span>
                                        <input type="search" class="search-field" placeholder="Search...">
                                    </label>
                                    <button type="submit"><feather type="search"></feather></button>
                                </form>
                            </section>

                            <section class="widget widget_startp_posts_thumb">
                                <h3 class="widget-title">Popular Posts</h3>

                                <article class="item">
                                    <router-link to="/blog-details/WhyECommerce" class="thumb">
                                        <span class="fullimage cover bg1" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 10, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/WhyECommerce">How can eCommerce help your business?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>

                                <article class="item">
                                    <router-link to="/blog-details/NeedWebSide" class="thumb">
                                        <span class="fullimage cover bg2" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 21, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/NeedWebSide">Why does your business need a website?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>

                                <article class="item">
                                    <router-link to="/blog-details/NeedDigitalMarketing" class="thumb">
                                        <span class="fullimage cover bg3" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 30, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/NeedDigitalMarketing">Why does your business need digital marketing?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>
                                
                                <article class="item">
                                    <router-link to="/blog-details/WhyRestudent" class="thumb">
                                        <span class="fullimage cover bg4" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 30, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/WhyRestudent">Why does your restaurant need an online website?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>
                                
                                <article class="item">
                                    <router-link to="/blog-details/AppVsWeb" class="thumb">
                                        <span class="fullimage cover bg5" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 30, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/AppVsWeb">App vs Website: which one is better?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>
                                
                                <article class="item">
                                    <router-link to="/blog-details/NeedApps" class="thumb">
                                        <span class="fullimage cover bg6" role="img"></span>
                                    </router-link>
                                    <div class="info">
                                        <time datetime="2021-06-30">June 30, 2021</time>
                                        <h4 class="title usmall"><router-link to="/blog-details/NeedApps">Why does your business need an app?</router-link></h4>
                                    </div>

                                    <div class="clear"></div>
                                </article>
                            </section>
                        </aside>
                    </div>
            </div>
            </div>
        </section>
        <!-- End Blog Details Area -->
    </div>
</template>

<script>
export default {
    name: 'NeedApps'
}
</script>